import axios from '../http'

function query(data) {
    return axios.post('/event/starter/query', data);
}


function get(id) {
    return axios.get('/event/starter/get?id=' + id);
}

  
export default {
    query,
    get
}